document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.content-switcher').forEach((switcher) => {
		const steps = [...switcher.querySelectorAll('.content-switcher-item-step')];
		const images = switcher.querySelectorAll('.content-switcher-item-image');

		// Set the active step
		const setActive = (index) => {
			steps.forEach((step, i) => {
				const isActive = i === index;
				step.classList.toggle('active', isActive);
				step.setAttribute('aria-selected', isActive);
				step.setAttribute('tabindex', isActive ? '0' : '-1');
			});

			images.forEach((image, i) => {
				const isActive = i === index;
				image.classList.toggle('active', isActive);
				image.toggleAttribute('aria-hidden', !isActive);
			});
		};

		// Go through each step and add event listeners
		steps.forEach((step, i) => {
			step.addEventListener('click', () => {
				setActive(i);
				step.focus();
			});

			step.addEventListener('mouseenter', () => setActive(i));

			step.addEventListener('keydown', (e) => {
				const total = steps.length;
				const map = {
					ArrowDown: (i + 1) % total,
					ArrowRight: (i + 1) % total,
					ArrowUp: (i - 1 + total) % total,
					ArrowLeft: (i - 1 + total) % total,
					Home: 0,
					End: total - 1,
				};

				if (e.key in map) {
					e.preventDefault();
					setActive(map[e.key]);
					steps[map[e.key]].focus();
				}
			});
		});
	});
});
